import styled from "styled-components";
import { readableColor } from "polished";

export default styled.span.attrs((props: any) => ({
  color: props.theme.colors[props.color || "primary"]
}))`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: ${props => props.theme.sizes.mega}rem;
  background-color: ${props => props.color};
  color: ${props => readableColor(props.color)};
  padding: 0 ${props => props.theme.sizes.normal}rem;
  font-size: ${props => props.theme.fontSizes.small}rem;
  font-weight: 500;
  height: 1.25rem;
`;
